import React from 'react';
import { FiRefreshCw, FiShield, FiAlertCircle, FiCreditCard } from 'react-icons/fi';

const ReturnsRefunds = () => {
  return (
    <div className="bg-white">
      <section className="bg-[#111111] text-white py-12 md:py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-3xl md:text-4xl font-bold mb-4">
            Returns, Exchanges & Refunds
          </h1>
          <p className="text-gray-300 text-base md:text-lg max-w-2xl mx-auto">
            At BeyondXL, we want you to love what you wear. If something isn&apos;t right, we&apos;re here to help.
          </p>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="space-y-10">
          <article className="border border-gray-200 rounded-xl p-6 md:p-8">
            <div className="flex items-center gap-3 mb-4">
              <FiRefreshCw className="text-[#e4ac16]" size={24} />
              <h2 className="text-xl md:text-2xl font-bold text-gray-900">Returns & Exchanges</h2>
            </div>
            <ul className="space-y-3 text-gray-700 leading-relaxed">
              <li>Returns and exchanges can be requested within <strong>7 days</strong> of delivery.</li>
              <li>Your <strong>first order</strong> is eligible for a <strong>free return or exchange</strong>.</li>
              <li>
                All subsequent orders are eligible for <strong>free size exchanges</strong>. Returns may be subject to a nominal return processing fee.
              </li>
              <li>
                Products must be <strong>unused, unwashed, undamaged</strong>, and returned with original tags and packaging intact.
              </li>
            </ul>
          </article>

          <article className="border border-gray-200 rounded-xl p-6 md:p-8">
            <div className="flex items-center gap-3 mb-4">
              <FiAlertCircle className="text-[#e4ac16]" size={24} />
              <h2 className="text-xl md:text-2xl font-bold text-gray-900">Damaged, Defective or Incorrect Items</h2>
            </div>
            <ul className="space-y-3 text-gray-700 leading-relaxed">
              <li>
                If you receive a damaged, defective, or incorrect product, please contact us within <strong>48 hours</strong> of delivery with clear photos of the issue.
              </li>
              <li>
                Verified damaged, defective, or incorrect products will be <strong>replaced or refunded at no additional cost</strong>.
              </li>
            </ul>
          </article>

          <article className="border border-gray-200 rounded-xl p-6 md:p-8">
            <div className="flex items-center gap-3 mb-4">
              <FiCreditCard className="text-[#e4ac16]" size={24} />
              <h2 className="text-xl md:text-2xl font-bold text-gray-900">Refunds</h2>
            </div>
            <ul className="space-y-3 text-gray-700 leading-relaxed">
              <li>Refunds for prepaid orders will be processed to the <strong>original payment method</strong>.</li>
              <li>
                Refunds for Cash on Delivery (COD) orders will be processed to a <strong>bank account or UPI ID</strong> provided by the customer.
              </li>
              <li>
                Refunds are typically processed within <strong>5–7 business days</strong> after the returned product passes quality inspection.
              </li>
            </ul>
          </article>

          <article className="border border-gray-200 rounded-xl p-6 md:p-8 bg-gray-50">
            <div className="flex items-center gap-3 mb-4">
              <FiShield className="text-[#e4ac16]" size={24} />
              <h2 className="text-xl md:text-2xl font-bold text-gray-900">Important Notes</h2>
            </div>
            <ul className="space-y-3 text-gray-700 leading-relaxed">
              <li>
                BeyondXL reserves the right to reject returns that do not meet the conditions mentioned above.
              </li>
              <li>
                Excessive or repeated return requests may be reviewed and declined at our discretion.
              </li>
              <li>
                For any assistance, please contact our customer support team and we&apos;ll be happy to help.
              </li>
            </ul>
          </article>
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600">
            For any assistance, please reach out to our customer support team and we&apos;ll be happy to help.
          </p>
        </div>
      </section>
    </div>
  );
};

export default ReturnsRefunds;
